import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Dialog,
  DialogContent,
  Divider,
  Fade,
  FormHelperText,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Skeleton,
  Stack,
  styled,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
} from "@mui/material";
import UPLOAD_OUTLINE from "../../assets/icons/upload-outline.png";
import {
  CARD_SAVE_BTN,
  CHOOSE_IMG_BTN,
  HELPER_TEXT,
  IMAGE_DEL_BTN,
  IMAGE_DROPZONE,
  IMAGE_META_TEXT,
  IMAGE_UPLOAD_DROP_TEXT,
  IMG_TYPE_BTN,
  ITEM_CARD_DIVIDER,
  ITEM_CARD_FILTER_APPLY_BTN,
  ITEM_CARD_LABEL,
  ITEM_CARD_MENU_ITEM,
  ITEM_CARD_PAPER,
  ITEM_CARD_SELECT_MENU,
  ITEM_CARD_SELECT_WRAPPER,
  ITEM_CARD_VALUE,
  ITEM_CARD_WRAPPER,
  PRODUCT_IMAGE_MODAL,
  PRODUCT_IMAGE_MODAL_HEADER,
  PRODUCT_IMAGE_PRIMARY_TEXT,
  PRODUCT_IMAGE_PRIMARY_WRAPPER,
  PRODUCT_IMAGE_WRAPPER,
  PRODUCT_TITLE,
  STATUS_BTN,
  STATUS_MENUITEM,
  STATUS_MENUITEM_TEXT,
  STATUS_MENULIST_WRAPPER,
  UPLOAD_CAPTION,
  WARNING_DAILOG_ACTION_NO,
  WARNING_DAILOG_ACTION_TEXT,
  WARNING_DAILOG_ACTION_YES,
  WARNING_DAILOG_HEADER,
  WARNING_DAILOG_TEXT,
  WARNING_DAILOG_TITLE,
  WARNING_DAILOG_WRAPPER,
} from "../styles";
import { format, isValid } from "date-fns";
import PRODUCT_PLACEHOLDER from "../../assets/images/product_placeholder.png";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  ArrowDropDown,
  CheckBox,
  CheckBoxOutlineBlank,
  ChevronLeft,
  ChevronRight,
  Circle,
  Close,
  Delete,
  Done,
  EditOutlined,
  Error,
  ErrorOutline,
  ExpandMore,
  InfoOutlined,
  ManageHistory,
  WarningAmber,
} from "@mui/icons-material";
import "./products.scss";
import React from "react";
import _ from "lodash";
import { useDropzone } from "react-dropzone";
import UPLOAD_ICON from "../../assets/icons/upload_gray.png";
import { arrayMoveImmutable } from "array-move";
import { NOTE_CHARACTER_LIMIT } from "../../utils/constants";
import { ActivityModal } from "./ActivityModal";

import UPC_ICON from "../../assets/icons/upc.png";
import SOURCE_ICON from "../../assets/icons/source.png";
import BRAND_ICON from "../../assets/icons/brand.png";
import SIZE_ICON from "../../assets/icons/size.png";
import PACK_ICON from "../../assets/icons/pack.png";
import { isValidHttpUrl } from "../../services/helper";

export const BootstrapTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip
      arrow
      classes={{ popper: className }}
      placement="top-start"
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 300 }}
      {...props}
    />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#0F3D61",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#0F3D61",
    borderRadius: "8px",
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(14),
    color: "#FFFFFF",
    padding: "12px",
  },
}));

const ItemCard = (props: any) => {
  const {
    data,
    isSelected = false,
    isPageAllSelected = false,
    onRowSelection,
    onProductTitleChange,
    onLongDescChange,
    onIngChange,
    onUploadImages,
    onNoteChange,
    onCarouselClick,
    openImageCarousel,
    onStatusUpdate,
    onSaveChanges,
    recordLoading = false,
  } = props;
  const [anchorElSD, setAnchorElSD] = React.useState<null | HTMLElement>(null);
  const openSD = Boolean(anchorElSD);

  const [anchorElLD, setAnchorElLD] = React.useState<null | HTMLElement>(null);
  const openLD = Boolean(anchorElLD);

  const [anchorElIng, setAnchorElIng] = React.useState<null | HTMLElement>(
    null
  );
  const openIng = Boolean(anchorElIng);

  const [openImageModal, setOpenImageModal] = React.useState<boolean>(false);
  const [uploadedImages, setUploadedImages] = React.useState<any>([]);
  const [note, setNote] = React.useState<string>(data?.Comments || "");
  const [isImageUpdated, setIsImageUpdated] = React.useState<boolean>(false);

  const [showDeleteWarning, setShowDeleteWarning] =
    React.useState<boolean>(false);
  const [deletedImage, setDeletedImage] = React.useState<any>(null);
  const [imageUrls, setImageUrls] = React.useState<string[]>([]);
  const [openActivityModal, setOpenActivityModal] =
    React.useState<boolean>(false);
  const [anchorElStatus, setAnchorElStatus] =
    React.useState<null | HTMLElement>(null);
  const openStatus = Boolean(anchorElStatus);

  React.useEffect(() => {
    setNote(data?.Comments || "");
  }, [data?.Comments]);

  React.useEffect(() => {
    if (!_.isEmpty(data?.Images)) {
      setUploadedImages(_.cloneDeep(data?.Images));
      setImageUrls([]);
      setDeletedImage(null);
    }
  }, [data?.Images]);

  const onDrop = React.useCallback((acceptedFiles: any[]) => {
    let fileObjects: any[] =
      (_.isEmpty(uploadedImages)
        ? _.cloneDeep(data?.Images)
        : _.cloneDeep(uploadedImages)) || [];
    acceptedFiles.forEach((file) => {
      const tempItem = {
        file,
        Image: URL.createObjectURL(file),
        Primary: false,
        Selected: true,
        Source: "User Input",
        ImageType: "O",
      };
      fileObjects.push(tempItem);
    });
    setUploadedImages(fileObjects);
    setIsImageUpdated(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/jpeg": [],
    },
    multiple: true,
  });

  const sdInputEl = React.useRef(null);
  const ldInputEl = React.useRef(null);
  const ingInputEl = React.useRef(null);

  const handleSDClick = (_event: React.MouseEvent<HTMLElement>) => {
    setAnchorElSD(sdInputEl.current);
  };

  const handleLDClick = (_event: React.MouseEvent<HTMLElement>) => {
    setAnchorElLD(ldInputEl.current);
  };

  const handleIngClick = (_event: React.MouseEvent<HTMLElement>) => {
    setAnchorElIng(ingInputEl.current);
  };

  const getImages = (imageArr: any[] = []) => {
    const filteredImages = _.filter(imageArr, ["Selected", true]) || [];
    if (!_.isEmpty(filteredImages)) {
      return (
        <Stack minWidth={126} height={186}>
          <Carousel
            showArrows={true}
            axis={"horizontal"}
            showThumbs={false}
            showIndicators={false}
            statusFormatter={(current, total) => `${current}/${total} Image(s)`}
            renderArrowPrev={(onClickHandler, _hasPrev, label) => (
              <IconButton
                aria-label="prev"
                onClick={onClickHandler}
                title={label}
                sx={{ width: 24, height: 24 }}
              >
                <ChevronLeft />
              </IconButton>
            )}
            renderArrowNext={(onClickHandler, _hasNext, label) => (
              <IconButton
                aria-label="prev"
                onClick={onClickHandler}
                title={label}
                sx={{ width: 24, height: 24 }}
              >
                <ChevronRight />
              </IconButton>
            )}
            onClickItem={(currentIndex, _item) =>
              onCarouselClick(filteredImages, `#${data?.UPC}`, currentIndex)
            }
          >
            {filteredImages.map((image: any, index: number) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  maxWidth: 100,
                  height: 120,
                  cursor: "pointer",
                }}
                key={`prd_image_${index}`}
              >
                <img
                  src={
                    isValidHttpUrl(image.Image)
                      ? image.Image
                      : `${window?.location?.origin}/${image.Image}`
                  }
                  alt={`product_image_${index}`}
                  style={{
                    height: "100%",
                    width: "auto",
                    overflow: "hidden",
                    objectFit: "contain",
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = PRODUCT_PLACEHOLDER;
                  }}
                />
              </div>
            ))}
          </Carousel>
        </Stack>
      );
    } else {
      return (
        <Stack
          minWidth={126}
          height={186}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <img
            src={PRODUCT_PLACEHOLDER}
            style={{ maxHeight: 150 }}
            alt={"product_image"}
          />
        </Stack>
      );
    }
  };

  const getTitleText = (sdItems: any[]) => {
    if (!_.isEmpty(sdItems)) {
      const res = _.find(sdItems, "Selected") || null;
      if (res && !_.isNil(res?.Sdesc)) {
        return res.Sdesc;
      }
    }
    return "";
  };

  const getLongDesc = (ldItems: any[]) => {
    if (!_.isEmpty(ldItems)) {
      const res = _.find(ldItems, "Selected") || null;
      if (res && !_.isNil(res?.Ldesc)) {
        return res.Ldesc;
      }
    }
    return "";
  };

  const getIngDesc = (ingItems: any[]) => {
    if (!_.isEmpty(ingItems)) {
      const res = _.find(ingItems, "Selected") || null;
      if (res && !_.isNil(res?.Ingredients)) {
        return res.Ingredients;
      }
    }
    return "";
  };

  const onSDMenuItemClick = (e: any, sdArr: any, item: any) => {
    onProductTitleChange(e, sdArr, item);
    setAnchorElSD(null);
  };

  const onLDMenuItemClick = (e: any, ldArr: any, item: any) => {
    onLongDescChange(e, ldArr, item);
    setAnchorElLD(null);
  };

  const onIngMenuItemClick = (e: any, ingArr: any, item: any) => {
    onIngChange(e, ingArr, item);
    setAnchorElIng(null);
  };

  const getProductTitle = (data: any[]) => {
    if (_.isEmpty(data)) {
      return "";
    }
    const title = _.find(data, "Selected") || null;
    return !_.isEmpty(title) ? title?.Sdesc : "";
  };

  const onChooseImage = (_images: any[]) => {
    setOpenImageModal(true);
  };

  const onImageSelection = (
    event: React.ChangeEvent<HTMLInputElement>,
    item: any,
    index: number
  ) => {
    const tempImages = _.clone(uploadedImages);
    tempImages.map((tmp: any, i: number) => {
      if (tmp.Image === item.Image && i === index) {
        tmp.Selected = event.target.checked;
      }
      return tmp;
    });
    setUploadedImages(tempImages);
    setIsImageUpdated(true);
  };

  const handleImageTypeChange = (
    _event: React.MouseEvent<HTMLElement>,
    newType: string | null,
    item: any,
    index: number
  ) => {
    const tempImages = _.clone(uploadedImages);
    tempImages.map((tmp: any, i: number) => {
      if (tmp.Image === item.Image && i === index) {
        tmp["ImageType"] = newType;
      }
      return tmp;
    });
    setUploadedImages(tempImages);
    setIsImageUpdated(true);
  };

  const onPrimarySelection = (image: any, oldIndex: number) => {
    if (image) {
      const tempImages = _.clone(uploadedImages);
      tempImages.map((img: any, index: number) => {
        if (index === oldIndex) {
          img["Primary"] = true;
        } else {
          img["Primary"] = false;
        }
        return img;
      });
      setUploadedImages(arrayMoveImmutable(tempImages, oldIndex, 0));
      setIsImageUpdated(true);
    }
  };

  const onApplyChanges = () => {
    setOpenImageModal(false);
    if (isImageUpdated) {
      console.log("Image Updated!");
      setTimeout(() => {
        onUploadImages(uploadedImages, data, imageUrls);
      }, 200);
    }
  };

  const onImageModalClose = () => {
    setOpenImageModal(false);
    setDeletedImage(null);
    setImageUrls([]);
    setUploadedImages(_.cloneDeep(data?.Images) || []);
    setIsImageUpdated(false);
  };

  const handleNoteChange = (e: any) => {
    setNote(e.target.value);
  };

  const getImageType = (type: "F" | "B" | "N" | "O") => {
    switch (type) {
      case "F":
        return "Front Side";
      case "B":
        return "Ingredients";
      case "N":
        return "Nutrition facts";
      case "O":
        return "Additional";

      default:
        return "";
    }
  };

  const handleDeleteConfirmProcess = () => {
    const tempImages = _.clone(uploadedImages);
    const deleteImageUrls: string[] = [];
    const finalImages = tempImages
      // eslint-disable-next-line
      .map((tmp: any, i: number) => {
        if (
          !(tmp.Image === deletedImage.Image.Image && i === deletedImage.index)
        ) {
          return tmp;
        } else {
          deleteImageUrls.push(tmp.Image);
        }
      })
      .filter((tmp1: any) => tmp1 !== undefined);
    setImageUrls(deleteImageUrls);
    setShowDeleteWarning(false);
    setUploadedImages(finalImages || []);
    setIsImageUpdated(true);
    setDeletedImage(null);
  };

  const handleStatusClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElStatus(event.currentTarget);
  };

  const handleStatusClose = () => {
    setAnchorElStatus(null);
  };

  const getStatusStyle = (s: string) => {
    switch (s) {
      case "Ready for Review":
        return {
          iconColor: "#0047D1",
          bgColor: "rgba(229, 237, 250, 0.84)",
        };
      case "In Review":
        return {
          iconColor: "#F8C239",
          bgColor: "rgba(250, 243, 227, 0.84)",
        };
      case "Approved":
        return {
          iconColor: "#077942",
          bgColor: "rgba(231, 243, 237, 0.84)",
        };
      case "Unapproved":
        return {
          iconColor: "#B80530",
          bgColor: "rgba(248, 230, 234, 0.84)",
        };
      case "Not ready for review":
        return {
          iconColor: "#7B31D8",
          bgColor: "rgba(242, 234, 251, 0.84)",
        };
      default:
        return {
          iconColor: "#0047D1",
          bgColor: "rgba(229, 237, 250, 0.84)",
        };
    }
  };

  const onStatusChange = (item: any, value: string) => {
    onStatusUpdate(item, value);
    setAnchorElStatus(null);
  };

  return (
    <React.Fragment key={data?.RecordId}>
      <Card sx={ITEM_CARD_WRAPPER}>
        <CardContent sx={{ p: 0, flex: 1 }}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            flex={1}
          >
            {recordLoading && isSelected ? (
              <Skeleton animation="wave" height={24} width="40%" />
            ) : (
              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={1.5}
                flex={1}
              >
                <Checkbox
                  sx={{ padding: 0 }}
                  icon={
                    <CheckBoxOutlineBlank
                      sx={{
                        color: "#6F7784",
                        borderRadius: "4px",
                        opacity: 0.6,
                      }}
                    />
                  }
                  checkedIcon={
                    <CheckBox sx={{ color: "#077942", borderRadius: "4px" }} />
                  }
                  checked={isSelected}
                  onChange={(e: any) => onRowSelection(e, data)}
                />
                <Typography sx={PRODUCT_TITLE}>
                  {getProductTitle(data?.ProductTitle || [])}
                </Typography>
              </Stack>
            )}
            {recordLoading && isSelected ? (
              <Skeleton animation="wave" height={24} width="50%" />
            ) : (
              <Stack
                direction={"row"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                flex={1}
                spacing={2}
              >
                <img src={UPLOAD_OUTLINE} alt="upload" height={24} />
                <Stack direction={"row"} alignItems={"center"}>
                  <Typography sx={UPLOAD_CAPTION}>File:</Typography>&nbsp;
                  <Typography sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}>
                    {data?.FileName || ""}
                  </Typography>
                </Stack>
                <Divider
                  orientation="vertical"
                  variant="middle"
                  sx={ITEM_CARD_DIVIDER}
                />
                <Stack direction={"row"} alignItems={"center"}>
                  <Typography sx={UPLOAD_CAPTION}>Posted on:</Typography>&nbsp;
                  <Typography sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}>
                    {data?.FileUploadDateTime &&
                    isValid(new Date(data?.FileUploadDateTime))
                      ? format(new Date(data?.FileUploadDateTime), "dd/MM/yyyy")
                      : ""}
                  </Typography>
                </Stack>
                <Stack direction={"row"} alignItems={"center"}>
                  <Typography sx={UPLOAD_CAPTION}>by:</Typography>&nbsp;
                  <Typography sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}>
                    {data?.UploadedBy || ""}
                  </Typography>
                </Stack>
                <Button
                  variant="contained"
                  startIcon={
                    <Circle
                      style={{
                        fontSize: 8,
                        color: getStatusStyle(data?.RecordStatus).iconColor,
                      }}
                    />
                  }
                  endIcon={
                    <ArrowDropDown style={{ fontSize: 18, color: "#6F7784" }} />
                  }
                  sx={{
                    ...STATUS_BTN,
                    ...{
                      background: getStatusStyle(data?.RecordStatus).bgColor,
                      "&:hover": {
                        background: getStatusStyle(data?.RecordStatus).bgColor,
                        boxShadow: "none",
                        border: "none",
                      },
                    },
                  }}
                  onClick={handleStatusClick}
                >
                  {data?.RecordStatus}
                </Button>
                <Menu
                  id="status-menu"
                  anchorEl={anchorElStatus}
                  open={openStatus}
                  onClose={handleStatusClose}
                  MenuListProps={{
                    "aria-labelledby": "status-button",
                    sx: STATUS_MENULIST_WRAPPER,
                  }}
                >
                  {data?.RecordStatus !== "Ready for Review" && (
                    <MenuItem
                      onClick={() => onStatusChange(data, "Ready for Review")}
                      sx={{
                        ...STATUS_MENUITEM,
                        background: getStatusStyle("Ready for Review").bgColor,
                      }}
                    >
                      <ListItemIcon style={{ minWidth: 16 }}>
                        <Circle
                          style={{
                            fontSize: 8,
                            color: getStatusStyle("Ready for Review").iconColor,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText sx={STATUS_MENUITEM_TEXT} disableTypography>
                        {"Ready for Review"}
                      </ListItemText>
                    </MenuItem>
                  )}
                  {data?.RecordStatus !== "In Review" && (
                    <MenuItem
                      onClick={() => onStatusChange(data, "In Review")}
                      sx={{
                        ...STATUS_MENUITEM,
                        background: getStatusStyle("In Review").bgColor,
                      }}
                    >
                      <ListItemIcon style={{ minWidth: 16 }}>
                        <Circle
                          style={{
                            fontSize: 8,
                            color: getStatusStyle("In Review").iconColor,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText sx={STATUS_MENUITEM_TEXT} disableTypography>
                        {"In Review"}
                      </ListItemText>
                    </MenuItem>
                  )}
                  {data?.RecordStatus !== "Approved" && (
                    <MenuItem
                      onClick={() => onStatusChange(data, "Approved")}
                      sx={{
                        ...STATUS_MENUITEM,
                        background: getStatusStyle("Approved").bgColor,
                      }}
                    >
                      <ListItemIcon style={{ minWidth: 16 }}>
                        <Circle
                          style={{
                            fontSize: 8,
                            color: getStatusStyle("Approved").iconColor,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText sx={STATUS_MENUITEM_TEXT} disableTypography>
                        {"Approved"}
                      </ListItemText>
                    </MenuItem>
                  )}
                  {data?.RecordStatus === "Approved" && (
                    <MenuItem
                      onClick={() => onStatusChange(data, "Unapproved")}
                      sx={{
                        ...STATUS_MENUITEM,
                        background: getStatusStyle("Unapproved").bgColor,
                      }}
                    >
                      <ListItemIcon style={{ minWidth: 16 }}>
                        <Circle
                          style={{
                            fontSize: 8,
                            color: getStatusStyle("Unapproved").iconColor,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText sx={STATUS_MENUITEM_TEXT} disableTypography>
                        {"Unapproved"}
                      </ListItemText>
                    </MenuItem>
                  )}
                  {data?.RecordStatus !== "Not ready for review" && (
                    <MenuItem
                      onClick={() =>
                        onStatusChange(data, "Not ready for review")
                      }
                      sx={{
                        ...STATUS_MENUITEM,
                        background: getStatusStyle("Not ready for review")
                          .bgColor,
                      }}
                    >
                      <ListItemIcon style={{ minWidth: 16 }}>
                        <Circle
                          style={{
                            fontSize: 8,
                            color: getStatusStyle("Not ready for review")
                              .iconColor,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText sx={STATUS_MENUITEM_TEXT} disableTypography>
                        {"Not ready for review"}
                      </ListItemText>
                    </MenuItem>
                  )}
                </Menu>
                <Divider
                  orientation="vertical"
                  variant="middle"
                  sx={ITEM_CARD_DIVIDER}
                />
                <IconButton
                  aria-label="logs"
                  sx={{ height: 20, width: 20, padding: 0 }}
                  onClick={() => setOpenActivityModal(true)}
                >
                  <ManageHistory sx={{ color: "#6F7784", fontSize: 20 }} />
                </IconButton>
              </Stack>
            )}
          </Stack>

          <Divider
            sx={{ background: "rgba(15, 61, 97, 0.08)", marginTop: 1 }}
          />

          <Stack direction={"row"} spacing={3} marginTop={1}>
            {recordLoading && isSelected ? (
              <Skeleton
                animation="wave"
                variant="rectangular"
                height={190}
                width={146}
              />
            ) : (
              <Stack spacing={1} width={146}>
                {getImages(uploadedImages)}
                <Button
                  variant="contained"
                  sx={CHOOSE_IMG_BTN}
                  onClick={() => onChooseImage(uploadedImages)}
                >
                  Choose Image
                </Button>
              </Stack>
            )}

            <Stack flex={1} spacing={0.5}>
              {recordLoading && isSelected ? (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height={40}
                  width={"100%"}
                />
              ) : (
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  spacing={2}
                  flex={1}
                >
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    spacing={2}
                    sx={{
                      borderRight: "1px solid #F1F2F3",
                      width: "18%",
                      paddingLeft: 2,
                    }}
                  >
                    <img src={UPC_ICON} alt={"upc_icon"} height={16} />
                    <Stack>
                      <Typography sx={ITEM_CARD_LABEL}>UPC</Typography>
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Typography sx={ITEM_CARD_VALUE}>
                          {data?.UPC || ""}
                        </Typography>
                        {data?.Source && !_.isEmpty(data?.Source) && (
                          <BootstrapTooltip
                            title={
                              <React.Fragment>
                                {data?.Source.map((s: string, i: number) => (
                                  <Typography
                                    key={`${s}_${i}`}
                                    fontSize={"inherit"}
                                  >{`• ${s}`}</Typography>
                                ))}
                              </React.Fragment>
                            }
                          >
                            <IconButton
                              disableFocusRipple
                              disableRipple
                              disableTouchRipple
                              sx={{ paddingY: 0 }}
                            >
                              <InfoOutlined
                                sx={{
                                  color: "#9DA1AE",
                                  fontSize: 16,
                                  "&:hover": {
                                    color: "#686C7E",
                                  },
                                }}
                              />
                            </IconButton>
                          </BootstrapTooltip>
                        )}
                      </Stack>
                    </Stack>
                  </Stack>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    spacing={2}
                    sx={{
                      borderRight: "1px solid #F1F2F3",
                      width: "28%",
                      paddingLeft: 2,
                    }}
                  >
                    <img src={SOURCE_ICON} alt={"source_icon"} height={16} />
                    <Stack>
                      <Typography sx={ITEM_CARD_LABEL}>
                        Source - ItemCode
                      </Typography>
                      <Typography sx={ITEM_CARD_VALUE}>
                        {data?.ItemCode || ""}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    spacing={2}
                    sx={{
                      borderRight: "1px solid #F1F2F3",
                      width: "28%",
                      paddingLeft: 2,
                    }}
                  >
                    <img src={BRAND_ICON} alt={"brand_icon"} height={16} />
                    <Stack>
                      <Typography sx={ITEM_CARD_LABEL}>Brand</Typography>
                      <Typography sx={ITEM_CARD_VALUE}>
                        {data?.Brand || ""}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    spacing={2}
                    sx={{
                      borderRight: "1px solid #F1F2F3",
                      width: "13%",
                      paddingLeft: 2,
                    }}
                  >
                    <img src={SIZE_ICON} alt={"size_icon"} height={16} />
                    <Stack>
                      <Typography sx={ITEM_CARD_LABEL}>Size</Typography>
                      <Typography sx={ITEM_CARD_VALUE}>
                        {data?.Size || ""}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    spacing={2}
                    sx={{ width: "13%", paddingLeft: 2 }}
                  >
                    <img src={PACK_ICON} alt={"pack_icon"} height={16} />
                    <Stack>
                      <Typography sx={ITEM_CARD_LABEL}>Pack</Typography>
                      <Typography sx={ITEM_CARD_VALUE}>
                        {data?.Pack || ""}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              )}

              {recordLoading && isSelected ? (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height={58}
                  width={"100%"}
                />
              ) : (
                <Stack
                  sx={ITEM_CARD_SELECT_WRAPPER}
                  direction={"row"}
                  alignItems={"center"}
                  spacing={1.5}
                >
                  {_.isEmpty(getTitleText(data?.ProductTitle || [])) ? (
                    <Error sx={{ fontSize: 16, color: "#BA0C2F" }} />
                  ) : (
                    <EditOutlined sx={{ fontSize: 16, color: "#6F7784" }} />
                  )}

                  <Stack flex={1}>
                    <InputLabel
                      htmlFor="product-title-select"
                      sx={{
                        ...ITEM_CARD_LABEL,
                        color: _.isEmpty(getTitleText(data?.ProductTitle || []))
                          ? "#BA0C2F"
                          : "#6F7784",
                      }}
                    >
                      Product Title*
                    </InputLabel>

                    <Stack direction={"row"} alignItems={"center"}>
                      <TextField
                        id="product-title-input"
                        label=""
                        variant="standard"
                        ref={sdInputEl}
                        value={getTitleText(data?.ProductTitle || [])}
                        error={_.isEmpty(
                          getTitleText(data?.ProductTitle || [])
                        )}
                        helperText={
                          _.isEmpty(getTitleText(data?.ProductTitle || []))
                            ? "This field is required."
                            : ""
                        }
                        FormHelperTextProps={{
                          sx: HELPER_TEXT,
                        }}
                        fullWidth
                        multiline
                        placeholder="Enter Product Title"
                        InputProps={{
                          sx: ITEM_CARD_SELECT_MENU,
                          // disableUnderline: true,
                        }}
                        onChange={(e: any) => onProductTitleChange(e, data)}
                      />
                      {!_.isEmpty(data?.ProductTitle || []) && (
                        <IconButton
                          aria-label="drop-arrow"
                          onClick={handleSDClick}
                        >
                          <ExpandMore sx={{ fontSize: 18, color: "#9DA1AE" }} />
                        </IconButton>
                      )}
                      <Menu
                        id="short-menu"
                        MenuListProps={{
                          "aria-labelledby": "short-button",
                        }}
                        anchorEl={anchorElSD}
                        open={openSD}
                        onClose={() => setAnchorElSD(null)}
                        PaperProps={{
                          sx: ITEM_CARD_PAPER,
                        }}
                      >
                        {(data?.ProductTitle || [])?.map(
                          (sd: any, sdIndex: number) => {
                            return (
                              <MenuItem
                                key={`title_${sdIndex}`}
                                sx={{ padding: 1 }}
                                selected={
                                  !_.isUndefined(sd.Selected)
                                    ? sd.Selected
                                    : false
                                }
                                onClick={(e: any) =>
                                  onSDMenuItemClick(e, data, sd)
                                }
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                  flex={1}
                                >
                                  <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    spacing={0.5}
                                    flexWrap={"wrap"}
                                  >
                                    <Typography sx={ITEM_CARD_MENU_ITEM}>
                                      {`${sd.Source}:`}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        ...ITEM_CARD_MENU_ITEM,
                                        color: "#282C36",
                                      }}
                                    >
                                      {`${sd.Sdesc}`}
                                    </Typography>
                                  </Stack>
                                  {sd.Selected && (
                                    <Done
                                      sx={{ color: "#66A640", fontSize: 16 }}
                                    />
                                  )}
                                </Stack>
                              </MenuItem>
                            );
                          }
                        )}
                      </Menu>
                    </Stack>
                  </Stack>
                </Stack>
              )}

              {recordLoading && isSelected ? (
                <Skeleton
                  animation="wave"
                  variant="rounded"
                  height={58}
                  width={"100%"}
                />
              ) : (
                <Stack
                  sx={ITEM_CARD_SELECT_WRAPPER}
                  direction={"row"}
                  alignItems={"center"}
                  spacing={1.5}
                >
                  {_.isEmpty(getLongDesc(data?.LongDescription || [])) ? (
                    <Error sx={{ fontSize: 16, color: "#BA0C2F" }} />
                  ) : (
                    <EditOutlined sx={{ fontSize: 16, color: "#6F7784" }} />
                  )}
                  <Stack flex={1}>
                    <InputLabel
                      htmlFor="long-desc-select"
                      sx={{
                        ...ITEM_CARD_LABEL,
                        color: _.isEmpty(
                          getLongDesc(data?.LongDescription || [])
                        )
                          ? "#BA0C2F"
                          : "#6F7784",
                      }}
                    >
                      Long Description*
                    </InputLabel>
                    <Stack direction={"row"} alignItems={"center"}>
                      <TextField
                        id="long-desc-input"
                        label=""
                        variant="standard"
                        ref={ldInputEl}
                        value={getLongDesc(data?.LongDescription || [])}
                        error={_.isEmpty(
                          getLongDesc(data?.LongDescription || [])
                        )}
                        helperText={
                          _.isEmpty(getLongDesc(data?.LongDescription || []))
                            ? "This field is required."
                            : ""
                        }
                        FormHelperTextProps={{
                          sx: HELPER_TEXT,
                        }}
                        fullWidth
                        multiline
                        maxRows={4}
                        placeholder="Enter Description"
                        InputProps={{
                          sx: ITEM_CARD_SELECT_MENU,
                        }}
                        onChange={(e: any) => onLongDescChange(e, data)}
                      />
                      {!_.isEmpty(data?.LongDescription || []) && (
                        <IconButton
                          aria-label="drop-arrow"
                          onClick={handleLDClick}
                        >
                          <ExpandMore sx={{ fontSize: 18, color: "#686C7E" }} />
                        </IconButton>
                      )}
                      <Menu
                        id="long-menu"
                        MenuListProps={{
                          "aria-labelledby": "long-button",
                        }}
                        anchorEl={anchorElLD}
                        open={openLD}
                        onClose={() => setAnchorElLD(null)}
                        PaperProps={{
                          sx: ITEM_CARD_PAPER,
                        }}
                      >
                        {(data?.LongDescription || [])?.map(
                          (ld: any, ldIndex: number) => {
                            return (
                              <MenuItem
                                key={`long_desc_${ldIndex}`}
                                sx={{ padding: 1 }}
                                selected={
                                  !_.isUndefined(ld.Selected)
                                    ? ld.Selected
                                    : false
                                }
                                onClick={(e: any) =>
                                  onLDMenuItemClick(e, data, ld)
                                }
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                  flex={1}
                                >
                                  <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    spacing={0.5}
                                    flexWrap={"wrap"}
                                  >
                                    <Typography sx={ITEM_CARD_MENU_ITEM}>
                                      {`${ld.Source}:`}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        ...ITEM_CARD_MENU_ITEM,
                                        color: "#23242A",
                                      }}
                                    >
                                      {`${ld.Ldesc}`}
                                    </Typography>
                                  </Stack>
                                  {ld.Selected && (
                                    <Done
                                      sx={{ color: "#66A640", fontSize: 16 }}
                                    />
                                  )}
                                </Stack>
                              </MenuItem>
                            );
                          }
                        )}
                      </Menu>
                    </Stack>
                  </Stack>
                </Stack>
              )}

              {recordLoading && isSelected ? (
                <Skeleton
                  animation="wave"
                  variant="rounded"
                  height={58}
                  width={"100%"}
                />
              ) : (
                <Stack
                  sx={ITEM_CARD_SELECT_WRAPPER}
                  direction={"row"}
                  alignItems={"center"}
                  spacing={1.5}
                >
                  <EditOutlined sx={{ fontSize: 16, color: "#6F7784" }} />
                  <Stack flex={1}>
                    <InputLabel htmlFor="ing-select" sx={ITEM_CARD_LABEL}>
                      Ingredients
                    </InputLabel>

                    <Stack direction={"row"} alignItems={"center"}>
                      <TextField
                        id="ing-input"
                        label=""
                        variant="standard"
                        ref={ingInputEl}
                        value={getIngDesc(data?.Ingredients || [])}
                        fullWidth
                        multiline
                        maxRows={4}
                        placeholder="Enter Ingredients"
                        InputProps={{
                          sx: ITEM_CARD_SELECT_MENU,
                        }}
                        onChange={(e: any) => onIngChange(e, data)}
                      />
                      {!_.isEmpty(data?.Ingredients || []) && (
                        <IconButton
                          aria-label="drop-arrow"
                          onClick={handleIngClick}
                        >
                          <ExpandMore sx={{ fontSize: 18, color: "#686C7E" }} />
                        </IconButton>
                      )}
                      <Menu
                        id="ing-menu"
                        MenuListProps={{
                          "aria-labelledby": "ing-button",
                        }}
                        anchorEl={anchorElIng}
                        open={openIng}
                        onClose={() => setAnchorElIng(null)}
                        PaperProps={{
                          sx: ITEM_CARD_PAPER,
                        }}
                      >
                        {(data?.Ingredients || [])?.map(
                          (ing: any, ingIndex: number) => {
                            return (
                              <MenuItem
                                key={`ing_${ingIndex}`}
                                sx={{ padding: 1 }}
                                selected={
                                  !_.isUndefined(ing.Selected)
                                    ? ing.Selected
                                    : false
                                }
                                onClick={(e: any) =>
                                  onIngMenuItemClick(e, data, ing)
                                }
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                  flex={1}
                                >
                                  <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    spacing={0.5}
                                    flexWrap={"wrap"}
                                  >
                                    <Typography sx={ITEM_CARD_MENU_ITEM}>
                                      {`${ing.Source}:`}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        ...ITEM_CARD_MENU_ITEM,
                                        color: "#23242A",
                                      }}
                                    >
                                      {`${ing.Ingredients}`}
                                    </Typography>
                                  </Stack>
                                  {ing.Selected && (
                                    <Done
                                      sx={{ color: "#66A640", fontSize: 16 }}
                                    />
                                  )}
                                </Stack>
                              </MenuItem>
                            );
                          }
                        )}
                      </Menu>
                    </Stack>
                  </Stack>
                </Stack>
              )}

              {recordLoading && isSelected ? (
                <Skeleton
                  animation="wave"
                  variant="rounded"
                  height={58}
                  width={"100%"}
                />
              ) : (
                <Stack
                  sx={ITEM_CARD_SELECT_WRAPPER}
                  direction={"row"}
                  alignItems={"center"}
                  spacing={1.5}
                >
                  <EditOutlined sx={{ fontSize: 16, color: "#6F7784" }} />
                  <Stack flex={1}>
                    <InputLabel htmlFor="ing-select" sx={ITEM_CARD_LABEL}>
                      Notes
                    </InputLabel>
                    <TextField
                      id="notes-input"
                      label=""
                      variant="standard"
                      placeholder="Enter Notes"
                      multiline
                      fullWidth
                      value={note}
                      helperText={
                        <FormHelperText
                          style={{ textAlign: "right", float: "right" }}
                          component={"span"}
                        >
                          {`${note.length || 0}/${NOTE_CHARACTER_LIMIT}`}
                        </FormHelperText>
                      }
                      InputProps={{
                        sx: ITEM_CARD_SELECT_MENU,
                      }}
                      inputProps={{
                        maxLength: NOTE_CHARACTER_LIMIT,
                      }}
                      onChange={handleNoteChange}
                      onBlur={() => onNoteChange(note, data)}
                    />
                  </Stack>
                </Stack>
              )}
            </Stack>
          </Stack>
        </CardContent>
        <CardActions
          disableSpacing
          sx={{ justifyContent: "flex-end", paddingRight: 0 }}
        >
          {recordLoading && isSelected ? (
            <Skeleton
              animation="wave"
              variant="rounded"
              height={30}
              width={52}
            />
          ) : (
            <Button
              variant="contained"
              sx={CARD_SAVE_BTN}
              disabled={isPageAllSelected || !isSelected}
              onClick={() => onSaveChanges(data?.RecordId)}
            >
              Save
            </Button>
          )}
        </CardActions>
      </Card>
      <Dialog
        onClose={onImageModalClose}
        open={openImageModal}
        PaperProps={{
          sx: {
            ...PRODUCT_IMAGE_MODAL,
            visibility: openImageCarousel ? "hidden" : "visible",
          },
        }}
      >
        <Stack spacing={3} flex={1}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            flex={1}
          >
            <Typography sx={PRODUCT_IMAGE_MODAL_HEADER}>
              Choose Product Image
            </Typography>
            <IconButton onClick={onImageModalClose}>
              <Close sx={{ fontSize: 18, color: "#6F7784" }} />
            </IconButton>
          </Stack>
          <Stack direction={"row"} spacing={2} flex={1}>
            <Stack spacing={3} flex={1.25}>
              <Box
                {...getRootProps({
                  className: "dropzone",
                })}
                sx={IMAGE_DROPZONE}
              >
                <input {...getInputProps()} />
                <img src={UPLOAD_ICON} alt={"upload"} height={60} />
                <Stack marginLeft={3}>
                  <Typography sx={IMAGE_UPLOAD_DROP_TEXT}>
                    <b>Click to upload</b> or drag and drop
                  </Typography>
                  <Typography sx={IMAGE_UPLOAD_DROP_TEXT}>
                    a JPG (Max. 1200*1200px)
                  </Typography>
                </Stack>
              </Box>
              {uploadedImages?.length > 0 && (
                <Stack spacing={1.5}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      lineHeight: "16px",
                      fontWeight: 500,
                      color: "#282C36",
                    }}
                  >
                    {uploadedImages.length > 1
                      ? `${uploadedImages.length} images available from source`
                      : `${uploadedImages.length} image available from source`}
                  </Typography>
                  <List
                    sx={{
                      width: "100%",
                      maxHeight: 320,
                      overflow: "auto",
                      height: "100%",
                    }}
                  >
                    {uploadedImages.map((value: any, i: number) => (
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        spacing={1}
                        mb={1}
                        key={`image-list_${value.Source}_${i}`}
                      >
                        <ListItem
                          disablePadding
                          sx={{
                            border: "1px solid rgba(15, 61, 97, 0.08)",
                            borderRadius: "4px",
                            padding: "0px 8px 8px",
                          }}
                        >
                          <Stack direction={"column"} flex={1}>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              justifyContent={"space-between"}
                              flex={1}
                            >
                              <ListItemButton
                                sx={{
                                  justifyContent: "space-between",
                                  paddingX: 1,
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                  },
                                }}
                                disableRipple
                                disableTouchRipple
                              >
                                <ListItemAvatar
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                  onClick={() =>
                                    onCarouselClick(
                                      uploadedImages,
                                      `#${data?.UPC}`,
                                      i
                                    )
                                  }
                                >
                                  <img
                                    src={
                                      isValidHttpUrl(
                                        value.Image || value.objectURL
                                      )
                                        ? value.Image || value.objectURL
                                        : `${window?.location?.origin}/${value.Image}`
                                    }
                                    alt={`db-img`}
                                    style={{
                                      height: 56,
                                      maxWidth: 56,
                                      width: "auto",
                                      overflow: "hidden",
                                      objectFit: "contain",
                                    }}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src = PRODUCT_PLACEHOLDER;
                                    }}
                                  />
                                </ListItemAvatar>
                                <ListItemText
                                  disableTypography
                                  primary={
                                    <Stack
                                      direction={"row"}
                                      alignItems={"center"}
                                      spacing={1}
                                      paddingLeft={3}
                                      paddingBottom={0.5}
                                    >
                                      <Typography
                                        sx={{
                                          ...IMAGE_META_TEXT,
                                          color: "#282C36",
                                        }}
                                      >
                                        From:
                                      </Typography>
                                      <Typography
                                        sx={{
                                          ...IMAGE_META_TEXT,
                                          color: "#282C36",
                                        }}
                                      >
                                        {value.Source}
                                      </Typography>
                                    </Stack>
                                  }
                                  secondary={
                                    <Stack
                                      direction={"row"}
                                      alignItems={"center"}
                                      spacing={1}
                                      paddingLeft={3}
                                    >
                                      {value?.dpi && (
                                        <>
                                          <Typography
                                            sx={IMAGE_META_TEXT}
                                          >{`${value?.dpi} dpi`}</Typography>
                                          <Typography sx={IMAGE_META_TEXT}>
                                            •
                                          </Typography>
                                        </>
                                      )}
                                      {value?.size && (
                                        <>
                                          <Typography
                                            sx={IMAGE_META_TEXT}
                                          >{`${value?.size}MB`}</Typography>
                                          <Typography sx={IMAGE_META_TEXT}>
                                            •
                                          </Typography>
                                        </>
                                      )}
                                      {value?.width && value?.height && (
                                        <Typography
                                          sx={IMAGE_META_TEXT}
                                        >{`${value?.width}*${value?.height}`}</Typography>
                                      )}
                                    </Stack>
                                  }
                                />
                              </ListItemButton>
                              <ListItemSecondaryAction
                                sx={{
                                  top: "25%",
                                  transform: "translateY(-25%)",
                                }}
                              >
                                <Checkbox
                                  sx={{ padding: 0 }}
                                  checked={value.Selected}
                                  icon={
                                    <CheckBoxOutlineBlank
                                      sx={{
                                        color: "#6F7784",
                                        borderRadius: "4px",
                                        opacity: 0.6,
                                      }}
                                    />
                                  }
                                  checkedIcon={
                                    <CheckBox
                                      sx={{
                                        color: "#077942",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  }
                                  onChange={(e: any) =>
                                    onImageSelection(e, value, i)
                                  }
                                />
                              </ListItemSecondaryAction>
                            </Stack>

                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              justifyContent={"space-between"}
                              flex={1}
                            >
                              <ToggleButton
                                value={value.Primary || false}
                                selected={value.Primary || false}
                                onChange={() => {
                                  onPrimarySelection(value, i);
                                }}
                                sx={{
                                  ...IMG_TYPE_BTN,
                                  marginRight: 0,
                                  "&.Mui-selected": {
                                    background: "#077942",
                                    border: "none",
                                    color: "#FFFFFF",
                                    "&:disabled": {
                                      opacity: 0.54,
                                    },
                                  },
                                }}
                                disabled={!value.Selected}
                              >
                                Primary
                              </ToggleButton>

                              <ToggleButtonGroup
                                value={value.ImageType}
                                exclusive
                                onChange={(event, val) =>
                                  handleImageTypeChange(event, val, value, i)
                                }
                                aria-label="image type"
                                size="small"
                              >
                                <ToggleButton
                                  value="F"
                                  aria-label="front"
                                  sx={IMG_TYPE_BTN}
                                  disabled={!value.Selected}
                                >
                                  Front side
                                </ToggleButton>
                                <ToggleButton
                                  value="B"
                                  aria-label="ingredients"
                                  sx={IMG_TYPE_BTN}
                                  disabled={!value.Selected}
                                >
                                  Ingredients
                                </ToggleButton>
                                <ToggleButton
                                  value="N"
                                  aria-label="nutrition"
                                  sx={IMG_TYPE_BTN}
                                  disabled={!value.Selected}
                                >
                                  Nutrition facts
                                </ToggleButton>
                                <ToggleButton
                                  value="O"
                                  aria-label="additional"
                                  sx={IMG_TYPE_BTN}
                                  disabled={!value.Selected}
                                >
                                  Additional
                                </ToggleButton>
                              </ToggleButtonGroup>

                              <IconButton
                                aria-label="delete"
                                sx={IMAGE_DEL_BTN}
                                onClick={() => {
                                  setDeletedImage({
                                    Image: value,
                                    index: i,
                                  });
                                  setTimeout(() => {
                                    setShowDeleteWarning(true);
                                  }, 200);
                                }}
                              >
                                <Delete
                                  sx={{ fontSize: 18, color: "#6F7784" }}
                                />
                              </IconButton>
                            </Stack>
                          </Stack>
                        </ListItem>
                      </Stack>
                    ))}
                  </List>
                </Stack>
              )}
            </Stack>
            <Stack
              justifyContent={"space-between"}
              flex={1}
              sx={{
                padding: "16px 24px",
                background: "rgba(241, 244, 249, 0.54)",
                border: "1px solid rgba(15, 61, 97, 0.08)",
                borderRadius: "8px",
              }}
            >
              <Stack spacing={1}>
                <Typography
                  sx={{
                    fontSize: 12,
                    lineHeight: "16px",
                    fontWeight: 500,
                    color: "#282C36",
                  }}
                >
                  Preview Images
                </Typography>
                <Stack
                  direction={"row"}
                  flexWrap={"wrap"}
                  sx={{ maxHeight: 374, overflow: "auto", height: "100%" }}
                >
                  {uploadedImages.map((img: any, index: number) => {
                    if (img.Selected) {
                      return (
                        <Stack
                          key={`upd_image_${index}`}
                          sx={{
                            background: "#FFFFFF",
                            border: "1px solid rgba(15, 61, 97, 0.08)",
                            borderRadius: "4px",
                            padding: "8px 4px 4px",
                            marginRight: 1,
                            marginBottom: 1,
                            width: 130,
                            height: 150,
                          }}
                          spacing={0.5}
                        >
                          <Typography
                            sx={{
                              fontSize: 9,
                              lineHeight: "12px",
                              fontWeight: 600,
                              color: "#6F7784",
                              textTransform: "uppercase",
                            }}
                          >
                            {getImageType(img.ImageType)}
                          </Typography>
                          <Box
                            key={`image_${data?.RecordId}_${index}`}
                            sx={PRODUCT_IMAGE_WRAPPER}
                          >
                            <img
                              src={
                                isValidHttpUrl(img.Image)
                                  ? img.Image
                                  : `${window?.location?.origin}/${img.Image}`
                              }
                              alt={`upload-img_${index}`}
                              style={{
                                height: "100%",
                                maxWidth: "100%",
                                width: "auto",
                                overflow: "hidden",
                                objectFit: "contain",
                              }}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = PRODUCT_PLACEHOLDER;
                              }}
                            />
                            {img.Primary && (
                              <Box sx={PRODUCT_IMAGE_PRIMARY_WRAPPER}>
                                <Typography sx={PRODUCT_IMAGE_PRIMARY_TEXT}>
                                  Primary
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Stack>
                      );
                    }
                    return <></>;
                  })}
                </Stack>
              </Stack>

              <Stack
                direction={"row"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                spacing={2}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: "19px",
                    fontWeight: 500,
                    color: "#282C36",
                  }}
                >
                  {_.filter(uploadedImages, "Selected").length > 1
                    ? `${
                        _.filter(uploadedImages, "Selected").length
                      } Images Selected`
                    : `${
                        _.filter(uploadedImages, "Selected").length
                      } Image Selected`}
                </Typography>
                <Button
                  variant="contained"
                  sx={ITEM_CARD_FILTER_APPLY_BTN}
                  onClick={onApplyChanges}
                >
                  Apply
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Dialog>
      <Dialog
        open={showDeleteWarning}
        PaperProps={{
          sx: WARNING_DAILOG_WRAPPER,
        }}
        onClose={() => {
          setDeletedImage(null);
          setShowDeleteWarning(false);
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Stack spacing={3}>
            <Stack spacing={3} sx={WARNING_DAILOG_HEADER}>
              <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                <WarningAmber style={{ fontSize: 18, color: "#B04509" }} />
                <Typography sx={WARNING_DAILOG_TITLE}>Warning</Typography>
              </Stack>
              <Stack spacing={1}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <ErrorOutline style={{ fontSize: 14, color: "#B04509" }} />
                  <Typography sx={WARNING_DAILOG_TEXT}>
                    {"This image will be removed permanently."}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack spacing={2}>
              <Typography sx={WARNING_DAILOG_ACTION_TEXT}>
                Would you like to delete the image?
              </Typography>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_NO}
                  onClick={() => {
                    setDeletedImage(null);
                    setShowDeleteWarning(false);
                  }}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  sx={WARNING_DAILOG_ACTION_YES}
                  onClick={handleDeleteConfirmProcess}
                >
                  Yes
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
      <ActivityModal
        openActivityModal={openActivityModal}
        recordID={data?.RecordId}
        upc={data?.UPC}
        onCloseActivityModal={() => setOpenActivityModal(false)}
      />
    </React.Fragment>
  );
};

export default ItemCard;
